<script>
import { getSaleStatusVariant, getSaleStatus } from "@src/helpers/sale";
import Badge from "./Badge.vue";

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  components: {
    Badge,
  },
  computed: {
    variant() {
      return getSaleStatusVariant(this.status);
    },
    saleStatus() {
      return getSaleStatus(this.status);
    },
  },
};
</script>

<template>
  <Badge :variant="variant" :label="saleStatus" />
</template>
